import dayjs from 'dayjs'
import { InterventionStatus } from '../types/fieldPost'

export type InterventionView = 'open' | 'closed' | 'all'

export const INTERVENTION_VIEWS: { key: InterventionView; label: string; statuses: InterventionStatus[] }[] = [
    { key: 'open', label: 'Open', statuses: [InterventionStatus.inProgress] },
    { key: 'closed', label: 'Closed', statuses: [InterventionStatus.completed, InterventionStatus.refusedCare] },
    { key: 'all', label: 'All', statuses: [InterventionStatus.inProgress, InterventionStatus.completed, InterventionStatus.refusedCare] },
]

export interface InterventionFilters {
    status?: InterventionStatus
    reason?: string
    disposition?: string
    area?: string
    from?: string
    to?: string
}

export interface SearchInterventionsParams {
    p_post_id: string
    p_statuses: string[]
    p_reason_ids: string[] | null
    p_disposition_ids: string[] | null
    p_areas: string[] | null
    p_from: string | null
    p_to: string | null
    p_search: string | null
    p_oldest_first: boolean
    p_limit: number
    p_offset: number
}

export function viewStatuses(view: InterventionView): InterventionStatus[] {
    return INTERVENTION_VIEWS.find(v => v.key === view)!.statuses
}

export function formatInterventionNumber(n: number): string {
    return String(n).padStart(6, '0')
}

export function searchInterventionsParams(
    postId: string,
    view: InterventionView,
    filters: InterventionFilters,
    search: string,
    range: { from: number; to: number },
): SearchInterventionsParams {
    const statuses = viewStatuses(view)
    const term = search.trim()
    return {
        p_post_id: postId,
        p_statuses: filters.status ? statuses.filter(s => s === filters.status) : statuses,
        p_reason_ids: filters.reason ? [filters.reason] : null,
        p_disposition_ids: filters.disposition ? [filters.disposition] : null,
        p_areas: filters.area ? [filters.area] : null,
        p_from: filters.from ? dayjs(filters.from).startOf('day').toISOString() : null,
        p_to: filters.to ? dayjs(filters.to).endOf('day').toISOString() : null,
        p_search: term || null,
        p_oldest_first: view === 'open',
        p_limit: range.to - range.from + 1,
        p_offset: range.from,
    }
}
